import { Recurso } from "lib.common/dist/CleanArch";
import { ErrExterno } from "lib.common/dist/errorHandler";
import { ApolloClient } from "@apollo/client";
import { GestionarCodProdTiendaDtSource } from "../../business/dataSources/GestionarCodProdTiendaDtSource";
import { ProductoTiendaDsKey } from "../../business/entities/ProductoTiendaDsKey";
import { AddDeleteCodProdTIendaParams, GetCodProdTIendaParams } from "../../utils/params/CodProdTIendaParams";
import { addCodProdTiendaGql, deleteCodProdTiendaGql, getCodProdTiendaGql } from "../../utils/queries/gestionarProdTienda";
import { gqlErrorsMapperRecurso } from "lib.front/dist/common/funErrorMappers";

export class GestionarCodProdTiendaDtSourceImplGql implements GestionarCodProdTiendaDtSource {
    private apolloClient: ApolloClient<object>;

    constructor(ApolloClient: ApolloClient<object>) {
        this.apolloClient = ApolloClient;
    }

    async addCodProductoTienda(input: AddDeleteCodProdTIendaParams): Promise<Recurso<ProductoTiendaDsKey>> {
        try {
            const variables = {
                shopCodProd: input.shopCodProd,
                idProdVerPres: input.idProdVerPres
            };

            const response = await this.apolloClient.mutate({
                mutation: addCodProdTiendaGql,
                variables
            });
            const errorRecurso = gqlErrorsMapperRecurso<ProductoTiendaDsKey>(response.errors);
            return errorRecurso ?? Recurso.fromData(response.data.agregarCodProdTienda);
        } catch (error) {
            return Recurso.fromError(new ErrExterno(error as Error));
        }
    }

    async deleteCodProdTienda(input: AddDeleteCodProdTIendaParams): Promise<Recurso<ProductoTiendaDsKey>> {
        try {
            const variables = {
                shopCodProd: input.shopCodProd,
                idProdVerPres: input.idProdVerPres
            };

            const response = await this.apolloClient.mutate({
                mutation: deleteCodProdTiendaGql,
                variables
            });
            const errorRecurso = gqlErrorsMapperRecurso<ProductoTiendaDsKey>(response.errors);
            return errorRecurso ?? Recurso.fromData(response.data.deleteCodProdTienda);
        } catch (error) {
            return Recurso.fromError(new ErrExterno(error as Error));
        }
    }
    
    async getCodProdTienda(input: GetCodProdTIendaParams): Promise<Recurso<ProductoTiendaDsKey[]>> {
        try {
            const variables = {
                shopCodProd: input.shopCodProd,
                idProdVerPres: input.idProdVerPres
            };

            const response = await this.apolloClient.query({
                query: getCodProdTiendaGql,
                variables
            });
            const errorRecurso = gqlErrorsMapperRecurso<ProductoTiendaDsKey[]>(response.errors);
            return errorRecurso ?? Recurso.fromData(response.data.codProdTiendaFiltro);
        } catch (error) {
            return Recurso.fromError<ProductoTiendaDsKey[]>(new ErrExterno(error as Error));
        }
    }
}